// extracted by mini-css-extract-plugin
export default {"schemaTextBox":"BodySchema_schemaTextBox__Of3OA"};